import type { UserTransactionReason } from '@/features/payouts/user-transaction-reason'
import { match } from '@/utils/pattern-match-util'

/**
 * Formats the transaction reason to a string.
 * @param reason
 */
export function formatTransactionReason(
  reason: UserTransactionReason | null | undefined,
): string {
  if (!reason) {
    return ''
  }

  return match(reason, {
    Unknown: () => 'Unknown',
    BackgroundCheck: () => 'Background check abatement',
    Penalty: () => 'Penalty abatement',
    Bonus: () => 'Bonus',
    MiscPayment: () => 'Misc. payment',
    MiscAbatement: () => 'Misc. abatement',
  })
}
